import React from "react";
import { cn } from "../../../lib/utils";
import { moduleColor } from "../utils/gatewayUtils";

interface GatewayModuleBadgeProps {
  module: string;
  className?: string;
}

export default function GatewayModuleBadge({ module, className }: GatewayModuleBadgeProps) {
  return (
    <span className={cn(
      "inline-flex items-center px-1.5 py-px rounded text-[10px] font-semibold border leading-4",
      moduleColor(module),
      className
    )}>
      {module}
    </span>
  );
}
